import { useContext, Fragment } from 'react';
import { Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import EnvIcon from '../../components/EnvIcon/EnvIcon.component';
import EnvSelector from '../../components/EnvSelector/EnvSelector.component';
import { SelectorContext } from '../../contexts/selector.context';
import { selectCurrentUser } from '../../store/user/user.selector';
import {
  NavigationContainer,
  NavLinks,
  NavLink,
  LogoContainer,
  CVLogo,
} from './navigation.styles';

const Navigation = () => {
  const currentUser = useSelector(selectCurrentUser);
  const { isSelectorOpen } = useContext(SelectorContext);

  return (
    <Fragment>
      <NavigationContainer>
        <LogoContainer to='/'>
          <CVLogo />
        </LogoContainer>
        <NavLinks>
          {currentUser ? (<NavLink to='/home'>DASHBOARD</NavLink>) : (<Fragment/>) }
          
          {currentUser ? (
            <NavLink to='/exit' >
              SIGN OUT
            </NavLink>
          ) : (
            <NavLink to='/auth'>SIGN IN</NavLink>
          )}
          { currentUser ? (<EnvIcon />) : (<Fragment/>) }

        </NavLinks>
        {isSelectorOpen && <EnvSelector />}
      </NavigationContainer>
      <Outlet />
    </Fragment>
  );
};

export default Navigation;